import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PortfolioContainer/constants";
const I18n = I18nUtil.createScoped(Translations);

export const ALL_PORTFOLIO_OPTION_ID = "all";

export const getAllPortfolioOption = () => {
  return {
    id: ALL_PORTFOLIO_OPTION_ID,
    label: I18n.t("All Holdings"),
  } as const;
};
